export default __webpack_public_path__ + "static/media/IMG_171323.6f609286.jpg";